import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FeatureFlagsState } from './feature-flags.reducer';
import {
  createDefaultFeatures,
  FeatureFlags,
} from '../../core/models/feature-flags.model';

/** Feature Flags Selectors */

export const selectFeatureFlagsState =
  createFeatureSelector<FeatureFlagsState>('featureFlags');

/** Select all feature flags */
export const selectFeatureFlags = createSelector(
  selectFeatureFlagsState,
  state => state?.flags ?? createDefaultFeatures()
);

/** Select whether LaunchDarkly client is ready */
export const selectFeatureFlagsReady = createSelector(
  selectFeatureFlagsState,
  state => state?.ready ?? false
);

/** Select whether feature flags are loading */
export const selectFeatureFlagsLoading = createSelector(
  selectFeatureFlagsState,
  state => state?.loading ?? false
);

/** Select error message if initialization failed */
export const selectFeatureFlagsError = createSelector(
  selectFeatureFlagsState,
  state => state?.error ?? null
);

/** Select specific flag: Use V2 API for Automation */
export const selectUseV2ApiForAutomation = createSelector(
  selectFeatureFlags,
  flags => flags?.payroll?.useV2ApiForAutomation ?? false
);

/** Select specific flag: Enable Diagnostic Page Access */
export const selectEnableDiagnosticPageAccess = createSelector(
  selectFeatureFlags,
  flags => flags?.diagnostics?.enableDiagnosticPageAccess ?? false
);

/**
 * Selector factory for dynamic boolean flag access by domain and property path
 * All feature flags are boolean-only (ON/OFF toggles)
 * @returns boolean value if flag exists, undefined if domain or property not found
 */
export const selectFlagByPath = (domain: string, property: string) =>
  createSelector(selectFeatureFlags, flags => {
    const domainFlags = flags?.[domain as keyof FeatureFlags];
    if (!domainFlags) return undefined;
    return domainFlags[property];
  });
